import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cliente-tarjeta',
  templateUrl: './cliente-tarjeta.component.html',
  styleUrls: ['./cliente-tarjeta.component.scss']
})
export class ClienteTarjetaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
